import React from 'react';
import { useStyletron } from 'baseui';
import { Accordion, Panel } from 'baseui/accordion';
import { Heading, HeadingLevel } from 'baseui/heading';
import { COLOURS } from '@gtintel/platform-utils';
import { AssignmentContext } from '../../AssignmentsApp/context';
import DueDatePill from '../../components/DueDatePill';
import { RequestStatusPill } from '../../components/RequestStatusIcon';
const RelatedAssignments = () => {
  const assignmentCtx = React.useContext(AssignmentContext);
  const [css] = useStyletron();
  const related_assignments = assignmentCtx.relatedAssignments();
  return <div className={css({
    marginTop: '28px'
  })}>
      <HeadingLevel>
        <Heading>Related Assignments</Heading>
        <Accordion accordion overrides={{
        Root: {
          style: {
            border: `2px solid ${COLOURS.borderGray}`,
            borderRadius: '8px',
            overflow: 'hidden'
          }
        }
      }}>
          {related_assignments.map(a => {
          return <Panel title={<div className={css({
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
          })}>
                    <div className={css({
              alignItems: 'center',
              display: 'flex',
              gap: '8px'
            })}>
                      <DueDatePill dueDate={a.due_date} submittedDate={a.submitted_date} />
                      {a.name ?? `Assignment #${a.id}`}
                    </div>
                    <RequestStatusPill status={a.status} />
                  </div>}>
                <HeadingLevel>
                  <Heading>Subjects</Heading>
                </HeadingLevel>
                {a.project.subjects.map(s => {
              return <p>{s.name}</p>;
            })}

                <HeadingLevel>
                  <Heading>Jurisdictions</Heading>
                </HeadingLevel>
                {Object.values(a.jurisdictions).map(j => {
              return <p>{j.name}</p>;
            })}

                <HeadingLevel>
                  <Heading>Services</Heading>

                  {Object.values(a.services.index).map(a => {
                return <div>
                        <HeadingLevel>
                          <Heading>{a.name}</Heading>
                        </HeadingLevel>
                        <div dangerouslySetInnerHTML={{
                    __html: a.description
                  }} />
                      </div>;
              })}
                </HeadingLevel>
              </Panel>;
        })}
        </Accordion>
      </HeadingLevel>
    </div>;
};
export default RelatedAssignments;